import { createBrowserHistory } from 'history'
import { EXIT_BOOKING_FLOW } from '@booking/constants'

export const LOCATION_CHANGE = 'LOCATION_CHANGE'

export const history = createBrowserHistory()

export function locationChange(location = '/') {
    return {
        type: LOCATION_CHANGE,
        payload: location,
    }
}

export function clearLastBookingDetails() {
    return {
        type: EXIT_BOOKING_FLOW,
    }
}

export const createLocationUpdater =
    ({ dispatch, getState }) =>
    nextLocation => {
        dispatch(locationChange(nextLocation))

        const locationState = getState().location
        const { currentLocation, prevLocation } = locationState
        const conditions = ['booking', 'dashboard/account', 'dashboard/credit-cards', 'dashboard/vehicles', 'basket']

        if (
            conditions.some(path => prevLocation.includes(path)) &&
            conditions.every(path => !currentLocation.includes(path))
        ) {
            dispatch(clearLastBookingDetails(nextLocation))
        }
    }

const initialState = { currentLocation: history.location.pathname, prevLocation: null }

export const reducers = {
    location: (state = initialState, action) =>
        action.type === LOCATION_CHANGE
            ? {
                  currentLocation: action.payload.pathname,
                  prevLocation: state.currentLocation,
              }
            : state,
}

const stateSelector = state => state.location
export const pathSelector = createSelector(stateSelector, state =>
    state && state.currentLocation ? state.currentLocation : null
)
